import scrollMonitor from 'scrollmonitor'
import slick from 'slick-carousel'
import has from 'lodash/has'
import qs from 'query-string'
import { requestTimeout, getHeaderOffset } from '../util'

const $slider = $('.advantages-slider ul')
const $grid = $('.advantages-grid')
const $weProvide = $('.we-provide-panel')
const $technologyItems = $('.industry-technology__items')
const $pageHeader = $('.page-header')
const $industryNav = $('.industry-nav')

const handleActiveGridItem = (index = 0) => {
  $('.advantages-grid button.grid-item--active').removeClass('grid-item--active')
  $(`.advantages-grid button[data-index=${index}]`).addClass('grid-item--active')

  $('.advantages-grid').toggleClass('advantages-grid--default', index === 0)
}

const setupSlider = () => {
  if (!$slider.length) {
    return
  }

  $slider.slick({
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dots: false
        }
      }
    ],
  })

  $slider.on('beforeChange', (e, slick, current, next) => {
    handleActiveGridItem(next)
  })

  $('.advantages-grid').on('click', 'button', e => {
    const index = $(e.currentTarget).data('index')

    $slider.slick('slickGoTo', index)
  })
}

const setupScroll = () => {
  const weProvideWatcher = scrollMonitor.create($weProvide.get(0), $weProvide.height())
  const gridWatcher = scrollMonitor.create($grid.get(0))
  const pageHeaderWatcher = scrollMonitor.create($pageHeader.get(0))

  weProvideWatcher.fullyEnterViewport(() => {
    $weProvide.find('.we-provide__item').each((index, el) => {
      const delay = (600 * (index + 1))

      requestTimeout(() => {
        $(el).addClass('item--active')
      }, delay)
    })

    weProvideWatcher.destroy()
  })

  const $panels = [
    $('#scroll-header'),
    $('#scroll-we-provide'),
    $('#scroll-advantage'),
    $('#scroll-technology')
  ]

  for (let $panel of $panels) {
    const panelWatcher = scrollMonitor.create($panel.get(0), $panel.height())

    const target = `#${$panel.prop('id')}`

    panelWatcher.fullyEnterViewport(() => {
      $(`.industry-nav a[data-target="${target}"]`).addClass('nav--active')
    })

    panelWatcher.partiallyExitViewport(() => {
      $(`.industry-nav a[data-target="${target}"]`).removeClass('nav--active')
    })
  }

  gridWatcher.fullyEnterViewport(() => {
    $grid.find('.grid__cell--hidden').sort(() => (Math.round(Math.random()) - 0.5)).each((index, el) => {
      const delay = (200 * (index + 1))

      requestTimeout(() => {
        $(el).removeClass('grid__cell--hidden')
      }, delay)
    })

    gridWatcher.destroy()
  })

  pageHeaderWatcher.exitViewport(() => {
    requestTimeout(() => {
      $industryNav.addClass('industry-nav--active')
    }, 200)
  })

  pageHeaderWatcher.enterViewport(() => {
    $industryNav.removeClass('industry-nav--active')
  })

  if ($technologyItems.length) {
    const technologyItemsWatcher = scrollMonitor.create($technologyItems.get(0))

    technologyItemsWatcher.enterViewport(() => {
      $('.industry-technology__items img').each((index, el) => {
        const delay = (200 * (index + 1))

        requestTimeout(() => {
          $(el).addClass('icon--active')
        }, delay)
      })

      technologyItemsWatcher.destroy()
    })
  }

  $industryNav.on('click', 'a', e => {
    e.preventDefault()

    const $target = $($(e.currentTarget).data('target'))

    let offset = getHeaderOffset()

    if ($target.prop('id') === 'scroll-technology') {
      offset = offset - ($target.height() / 2)
    }

    $.scrollTo($target, 400, { offset: -offset })
  })
}

export default {
  can: () => $('body').hasClass('pagetype-industrylandingpage'),
  run: () => {
    setupSlider()
    setupScroll()
  }
}
